import { useQuery } from '@tanstack/react-query';
import type { UseQueryReturnType } from '../@types';
import { gqlClient } from '../clients';
import { graphql } from '../gql';
import type { Catalogue_SystemSettingsFilter } from '../gql/graphql';
import { queryClient } from '../query-client';
import { coreApiKeys } from './keys';

const settingsValues = graphql(/* GraphQL */ `
 query catalogue_systemSettingsValues($filter: Catalogue_SystemSettingsFilter!) {
    catalogue_systemSettingsValues(filter: $filter) {
      attendance_subjectGroupAttendance_customSubjectGroupAttendanceCodes
      attendance_shareAttendanceNote_enabled
      security_dataPrivacy_confirmBeforeShowingSensitiveData
      security_logout_inactiveTimeUntilLogoutMinutes
      substitution_display_showAbsenceReason
      substitution_display_teacherDisplayNameType
      people_display_teacherDisplayNameType
      noticeboard_display_alwaysShowPinned
      communications_sms_studentSms
      schoolActivity_attendance_defaultAttendanceCode
      timetable_twoWeekTimetable_enabled
      timetable_construction_defaultToTableViewInBlockCores
      language_translation_enableSwitching
      featureFlag_settings_peapod
      featureFlag_attendance_sessionAttendance
      featureFlag_rulesEngine_rulesEnginePlus
      featureFlag_assessments_stateCba
      featureFlag_forms_newFormsSection
      featureFlag_security_advancedPermissions
      featureFlag_studentOptions_fullFeature
      featureFlag_userAccess_sds
      groupTags_groupsMenu_showProgrammeStages
      groupTags_groupsMenu_showYears
      groupTags_programmeStage_enabledStages
      security_summerMode_enabled
      behaviour_quickActions_list
      social_thirdParties_facebook
      social_thirdParties_instagram
      social_thirdParties_twitter
      attendance_signInOut_collectedBy
      attendance_overdue_numberOfDaysWidgetShows
    }
  }
`);

const settingsValuesQuery = (filter: Catalogue_SystemSettingsFilter) => ({
  queryKey: coreApiKeys.settingsValues(filter),
  queryFn: () => gqlClient.request(settingsValues, { filter }),
});

export function getSettingsValues(filter: Catalogue_SystemSettingsFilter) {
  return queryClient.fetchQuery(settingsValuesQuery(filter));
}

export function useSettingsValues(filter: Catalogue_SystemSettingsFilter) {
  return useQuery({
    ...settingsValuesQuery(filter),
    select: ({ catalogue_systemSettingsValues }) =>
      catalogue_systemSettingsValues,
  });
}

export type ReturnTypeFromUseSettingsValues = UseQueryReturnType<
  typeof useSettingsValues
>;
